import { useMemo } from 'react';
import { Badge, Box, Flex, Table, Tbody, Td, Text, Th, Thead, Tr, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import AmountDisplay from 'components/finance/AmountDisplay';
import { getCategoryName } from 'lib/finance';
import { useFinance } from 'contexts/FinanceContext';

export default function FinanceRecentTable() {
  const { transactions, categories } = useFinance();
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const recent = useMemo(() => transactions.slice(0, 5), [transactions]);

  return (
    <Card
      flexDirection="column"
      w="100%"
      px="0px"
      overflowX={{ sm: 'scroll', lg: 'hidden' }}
    >
      <Flex px="25px" mb="8px" justifyContent="space-between" align="center">
        <Text color={textColor} fontSize="22px" fontWeight="700" lineHeight="100%">
          Recent Transactions
        </Text>
        <Menu />
      </Flex>
      <Box>
        <Table variant="simple" color="gray.500" mb="24px" mt="12px">
          <Thead>
            <Tr>
              <Th pe="10px" borderColor={borderColor}>
                <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
                  DESCRIPTION
                </Text>
              </Th>
              <Th pe="10px" borderColor={borderColor}>
                <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
                  CATEGORY
                </Text>
              </Th>
              <Th pe="10px" borderColor={borderColor}>
                <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
                  TYPE
                </Text>
              </Th>
              <Th pe="10px" borderColor={borderColor} isNumeric>
                <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
                  AMOUNT
                </Text>
              </Th>
              <Th pe="10px" borderColor={borderColor}>
                <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400">
                  DATE
                </Text>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {recent.length === 0 ? (
              <Tr>
                <Td colSpan={5} textAlign="center" py="40px" borderColor={borderColor}>
                  No transactions yet
                </Td>
              </Tr>
            ) : (
              recent.map((tx) => (
                <Tr key={tx.id}>
                  <Td borderColor={borderColor}>
                    <Text color={textColor} fontSize="sm" fontWeight="700">
                      {tx.description || '—'}
                    </Text>
                  </Td>
                  <Td borderColor={borderColor}>
                    <Text color={textColor} fontSize="sm" fontWeight="700">
                      {getCategoryName(categories, tx.categoryId)}
                    </Text>
                  </Td>
                  <Td borderColor={borderColor}>
                    <Badge
                      colorScheme={tx.type === 'income' ? 'green' : 'red'}
                      textTransform="capitalize"
                    >
                      {tx.type}
                    </Badge>
                  </Td>
                  <Td borderColor={borderColor} isNumeric>
                    <AmountDisplay
                      amount={tx.amount}
                      type={tx.type}
                      fontSize="sm"
                    />
                  </Td>
                  <Td borderColor={borderColor}>
                    <Text color={textColor} fontSize="sm" fontWeight="700">
                      {tx.date}
                    </Text>
                  </Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>
    </Card>
  );
}
